export enum CompanyInfoStatusEnum {
  PENDING_REVIEW = 0,
  APPROVED = 1,
  REJECTED = 2,
  FROZEN = 3,
}
